// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessHardhat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.998 2.2a10.046 10.046 0 0 1 4.004 0 .75.75 0 0 1 1.498.05v.38c3.655 1.365 6.297 4.809 6.489 8.893a1.25 1.25 0 0 1-.19 2.476 9.993 9.993 0 0 1-2.728 5.072A10 10 0 0 1 2.201 14a1.25 1.25 0 0 1-.19-2.476C2.203 7.439 4.845 3.995 8.5 2.63v-.38a.75.75 0 0 1 1.498-.05zm-5.983 9.3h15.97A8.003 8.003 0 0 0 15.5 4.804V9.75a.75.75 0 0 1-1.5 0V4.252A8.015 8.015 0 0 0 12 4c-.69 0-1.36.088-2 .252V9.75a.75.75 0 0 1-1.5 0V4.804A8.003 8.003 0 0 0 4.015 11.5zm15.838 3.753c.169-.407.305-.826.408-1.253H3.74A8.497 8.497 0 0 0 12 20.5a8.501 8.501 0 0 0 7.853-5.247z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusinessHardhat;
